import React from 'react';
import { useParams } from 'react-router-dom';
import ReservationHistoryComponent from './ReservationHistoryComponent';
import reservationService from '../../../services/reservation.services';
import { useTranslation } from 'react-i18next';

interface RouteParams {
  id: string;
}

const ReservationHistoryPage: React.FC = () => {
  const { id } = useParams<RouteParams>();

  const { t } = useTranslation();

  if (!id) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h2>{t("app.reservation.page.invalid.id.h2")}</h2>
        <p>{t("app.reservation.page.invalid.id.paragraph")}</p>
      </div>
    );
  }

  return (
    <ReservationHistoryComponent
      reservationId={id}
      fetchReservationHistory={reservationService.fetchReservationHistory}
    />
  );
};

export default ReservationHistoryPage;